// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug-menu {
  position: absolute;
  top: 45px; /* Немного отступа от верхнего края */
  right: 10px;
  display: flex;
  flex-direction: column; /* Располагаем кнопки вертикально */
  gap: 5px; /* Промежуток между кнопками */
  background-color: rgba(0, 0, 0, 0.1); /* Полупрозрачный фон для лучшей видимости */
  padding: 8px;
  border-radius: 5px;
  z-index: 1000; /* Выше других элементов */
}

.debug-button {
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: white;
  transition: background-color 0.2s ease;
  min-width: 60px; /* Минимальная ширина для читаемости */
  text-align: center;
}

.debug-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.debug-button.borders {
  background-color: hsl(317, 91%, 74%); /* Зеленый */
}
.debug-button.animation {
  background-color: hsl(225, 63%, 67%); /* Зеленый */
}
.debug-button.initialize {
  background-color: #28a745; /* Зеленый */
}
.debug-button.initialize:hover:not(:disabled) {
  background-color: #218838;
}

.debug-button.autoplace {
  background-color: #007bff; /* Синий */
}
.debug-button.autoplace:hover:not(:disabled) {
  background-color: #0056b3;
}

.debug-button.autoplace-almost {
    background-color: #ffc107; /* Желтый */
    color: #333; /* Темный текст для желтого фона */
}
.debug-button.autoplace-almost:hover:not(:disabled) {
  background-color: #e0a800;
}

.debug-button.reset {
  background-color: #dc3545; /* Красный */
}
.debug-button.reset:hover:not(:disabled) {
  background-color: #c82333;
}

.debug-button.info-toggle {
  background-color: #6c757d; /* Серый */
  color: white;
  padding: 6px; /* Меньше паддинг для иконки */
  order: -1; /* Помещаем кнопку в начало (вверх) */
}

.debug-button.info-toggle:hover:not(:disabled) {
  background-color: #5a6268;
}

.debug-button.info-toggle.active {
  background-color: #17a2b8; /* Бирюзовый для активного состояния */
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.3);
}

.loading-indicator {
  color: #ccc;
  font-size: 12px;
  text-align: center;
  padding: 6px 10px;
} `, "",{"version":3,"sources":["webpack://./src/components/canvaspuzzle/components/debug/DebugMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS,EAAE,qCAAqC;EAChD,WAAW;EACX,aAAa;EACb,sBAAsB,EAAE,mCAAmC;EAC3D,QAAQ,EAAE,8BAA8B;EACxC,oCAAoC,EAAE,4CAA4C;EAClF,YAAY;EACZ,kBAAkB;EAClB,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,eAAe,EAAE,sCAAsC;EACvD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC,EAAE,YAAY;AACpD;AACA;EACE,oCAAoC,EAAE,YAAY;AACpD;AACA;EACE,yBAAyB,EAAE,YAAY;AACzC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;AACA;EACE,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB,EAAE,WAAW;IACtC,WAAW,EAAE,kCAAkC;AACnD;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,YAAY;AACzC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,YAAY,EAAE,8BAA8B;EAC5C,SAAS,EAAE,qCAAqC;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".debug-menu {\r\n  position: absolute;\r\n  top: 45px; /* Немного отступа от верхнего края */\r\n  right: 10px;\r\n  display: flex;\r\n  flex-direction: column; /* Располагаем кнопки вертикально */\r\n  gap: 5px; /* Промежуток между кнопками */\r\n  background-color: rgba(0, 0, 0, 0.1); /* Полупрозрачный фон для лучшей видимости */\r\n  padding: 8px;\r\n  border-radius: 5px;\r\n  z-index: 1000; /* Выше других элементов */\r\n}\r\n\r\n.debug-button {\r\n  padding: 6px 10px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  color: white;\r\n  transition: background-color 0.2s ease;\r\n  min-width: 60px; /* Минимальная ширина для читаемости */\r\n  text-align: center;\r\n}\r\n\r\n.debug-button:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.debug-button.borders {\r\n  background-color: hsl(317, 91%, 74%); /* Зеленый */\r\n}\r\n.debug-button.animation {\r\n  background-color: hsl(225, 63%, 67%); /* Зеленый */\r\n}\r\n.debug-button.initialize {\r\n  background-color: #28a745; /* Зеленый */\r\n}\r\n.debug-button.initialize:hover:not(:disabled) {\r\n  background-color: #218838;\r\n}\r\n\r\n.debug-button.autoplace {\r\n  background-color: #007bff; /* Синий */\r\n}\r\n.debug-button.autoplace:hover:not(:disabled) {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.debug-button.autoplace-almost {\r\n    background-color: #ffc107; /* Желтый */\r\n    color: #333; /* Темный текст для желтого фона */\r\n}\r\n.debug-button.autoplace-almost:hover:not(:disabled) {\r\n  background-color: #e0a800;\r\n}\r\n\r\n.debug-button.reset {\r\n  background-color: #dc3545; /* Красный */\r\n}\r\n.debug-button.reset:hover:not(:disabled) {\r\n  background-color: #c82333;\r\n}\r\n\r\n.debug-button.info-toggle {\r\n  background-color: #6c757d; /* Серый */\r\n  color: white;\r\n  padding: 6px; /* Меньше паддинг для иконки */\r\n  order: -1; /* Помещаем кнопку в начало (вверх) */\r\n}\r\n\r\n.debug-button.info-toggle:hover:not(:disabled) {\r\n  background-color: #5a6268;\r\n}\r\n\r\n.debug-button.info-toggle.active {\r\n  background-color: #17a2b8; /* Бирюзовый для активного состояния */\r\n  box-shadow: inset 0 1px 3px rgba(0,0,0,0.3);\r\n}\r\n\r\n.loading-indicator {\r\n  color: #ccc;\r\n  font-size: 12px;\r\n  text-align: center;\r\n  padding: 6px 10px;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
